import { ToastService } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';

export class ToastMsgUtils {
  public static toastSucessMessage(title: string, expression: string): void {
    const sucessMessage = MessageService.translate(expression);
    const titleMessage = MessageService.translate(title);
    ToastService.close('custom-toast');
    ToastService.open({
      dismissible: true,
      id: 'custom-toast',
      level: ToastLevel.SUCCESS,
      message: sucessMessage,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      title: titleMessage,
      type: ToastType.BUBBLE,
    });
  }

  public static toastErrorMessage(title: string, expression: string): void {
    const errorMenssage = MessageService.translate(expression);
    const titleMessage = MessageService.translate(title);
    ToastService.close('custom-toast');
    ToastService.open({
      dismissible: true,
      id: 'custom-toast',
      level: ToastLevel.ERROR,
      message: errorMenssage,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      title: titleMessage,
      type: ToastType.BUBBLE,
    });
  }
}
